document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('main .shopify-section');

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('mendi-visible');
        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.12
  });

  sections.forEach((section) => {
    section.classList.add('mendi-reveal');
    observer.observe(section);
  });
});